import React from 'react';
import FinancialEntryList from 'pages/app/financialEntries/FinancialEntryList';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { closeFinancialEntry } from 'stores/patients/patientActions';
import useAuth from 'core/hooks/useAuth';

const PatientFinancialEntryListInternal = ({ patientId }) => {
  const dispatch = useDispatch();
  const { hasRole } = useAuth();

  const handleClose = () => {
    dispatch(closeFinancialEntry());
  };

  return (
    <Modal visible width="90%" footer={null} onCancel={handleClose}>
      <FinancialEntryList
        resource="financial-entries"
        fixedQueryParams={{ patientIds: [patientId] }}
        useQueryStringParams={false}
        disableAccountingAlert
      />
    </Modal>
  );
};

const PatientFinancialEntryList = () => {
  const { visibleFinancialEntryPatientId } = useSelector(
    (c) => c.resources['financial-entries'] ?? {}
  );

  if (!visibleFinancialEntryPatientId) {
    return null;
  }

  return (
    <PatientFinancialEntryListInternal
      patientId={visibleFinancialEntryPatientId}
    />
  );
};

export default PatientFinancialEntryList;
